import { useEffect, useState } from 'react';
import {
  OPEN_COLLECTIVE_FALLBACK,
  SPONSORS_INPUT,
  MILESTONES,
} from '../constants';
import { useOpenCollectiveContext } from '../context/OpenCollectiveContext';

export const useMoneyStatistics = () => {
  const { statistic, isLoading } = useOpenCollectiveContext();

  const [current, setCurrent] = useState<number>(0);
  const [target, setTarget] = useState<number>(0);
  const [milestonesToShow, setMilestonesToShow] = useState<number[]>([]);

  useEffect(() => {
    const openCollective =
      statistic?.totalNetAmountReceived || OPEN_COLLECTIVE_FALLBACK;
    const current = SPONSORS_INPUT + openCollective;

    const target = MILESTONES.filter((milestone) => milestone > current)[0];
    setCurrent(current);
    setTarget(target);
    setMilestonesToShow(MILESTONES.filter((milestone) => milestone < target));
  }, [statistic, isLoading]);

  return {
    statistic,
    isLoading,
    current,
    target,
    milestonesToShow,
  };
};
